module.exports = __webpack_public_path__ + "img/corner-left-up.359fe6e5.svg";